// extracted by mini-css-extract-plugin
export default {"wapper":"QuotationsItems_wapper__7ZE8y","isVisualizerOpen":"QuotationsItems_isVisualizerOpen__ivHLw"};